import { render, staticRenderFns } from "./NotificationSearch.vue?vue&type=template&id=5e593778&scoped=true&"
import script from "./NotificationSearch.vue?vue&type=script&lang=ts&"
export * from "./NotificationSearch.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationSearch.vue?vue&type=style&index=0&id=5e593778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e593778",
  null
  
)

export default component.exports